import { Component, inject, OnInit } from '@angular/core';
import * as AOS from 'aos';
import { TranslateService } from '@ngx-translate/core';
import { FeathersService } from './core/services/api/feathers.service';
import { delay, tap } from 'rxjs';
import { TagsService } from './core/services/api/tags.service';
import {
  slideInUpOnEnterAnimation,
  slideOutDownOnLeaveAnimation,
} from 'angular-animations';
import { GlobalWrapperService } from './core/services/global-wrapper.service';
import { NavigationEnd, Router } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { RouterEventsService } from './core/services/router-events.service';
import { LinMatIconRegistryService } from './core/services/mat-icon-registry.service';

const PENDING_TAG_ANIMATION_DURATION = 100;

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'ling-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    slideInUpOnEnterAnimation({ duration: PENDING_TAG_ANIMATION_DURATION }),
    slideOutDownOnLeaveAnimation({ duration: PENDING_TAG_ANIMATION_DURATION }),
  ],
})
export class AppComponent implements OnInit {
  private readonly translateService = inject(TranslateService);
  protected readonly feathers = inject(FeathersService);
  protected readonly tagsService = inject(TagsService);
  protected readonly globalWrapperService = inject(GlobalWrapperService);
  protected readonly routerEventsService = inject(RouterEventsService);
  protected readonly uisMatIconRegistryService = inject(
    LinMatIconRegistryService
  );
  protected readonly router = inject(Router);

  protected readonly pendingTagId$ = this.tagsService.pendingTagId$;

  constructor() {
    this.translateService.addLangs(['en']);
    this.translateService.setDefaultLang('en');
    this.translateService.use('en');
  }

  isPreviewPage!: boolean;
  readyToShow = false;
  initialized$ = this.feathers.initialized$.pipe(
    tap((value) => (this.readyToShow = value)),
    delay(150)
  );

  ngOnInit() {
    AOS.init();
    this.tagsService.executePendingTagScans().subscribe();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isPreviewPage = event.url.includes('preview');
        this.routerEventsService.isPreviewPage$.next(this.isPreviewPage);
      }
    });
  }

  onDiscardPendingTagId() {
    this.tagsService.discardPendingTagId();
  }
}
